import { render, staticRenderFns } from "./PackageButtons.vue?vue&type=template&id=03c3d066&scoped=true"
import script from "./PackageButtons.vue?vue&type=script&lang=js"
export * from "./PackageButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c3d066",
  null
  
)

export default component.exports